import React, { useState } from "react";
import { Router, useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";

// import JS files
import { useAuth } from "../../../context/AuthContext";
import { MenuItem } from "../../../utils";
import { useUserData } from "../../../context/UserDataContext";
import EditCustomer from "../../admin-panels/setting/customer/EditCustomer";
import { EmployeeMenuItems } from "./EmployeeMenuItems";
import MuiDropDown from "../../shares/MuiDropDown";
import MuiBadge from "../../shares/MuiBadge";

// import Others files

const EmployeeSideBar = (props) => {
  let windowWidth = window.screen.width;
  const { userData, getUser } = useUserData();

  const navigate = useNavigate();
  const { authDispatch } = useAuth();

  const [openEditCustomerCard, setOpenEditCustomerCard] = useState(false);
  const handleEditCustomerModal = () => {
    setOpenEditCustomerCard((before) => !before);
  };

  return (
    <>
      {openEditCustomerCard && (
        <EditCustomer
          openModal={openEditCustomerCard}
          setOpenModal={setOpenEditCustomerCard}
          name={userData.user_customer[0].name}
          phone_number={userData.user_customer[0].phone_number}
          attach_file={userData.user_customer[0].attach_file}
          store_name={userData.user_customer[0].store_name}
          address={userData.user_customer[0].address}
          city={userData.user_customer[0].city}
          email={userData.user_customer[0].email}
          phone={userData.user_customer[0].phone}
          user={userData.username}
          userId={userData.user_customer[0].id}
          getFunc={getUser}
        />
      )}
      {/* Desktop Navbar Part */}
      <div className="hidden md:flex items-center justify-between">
        <div>
          <span className="font-bold text-yellow-200 text-xl">
            فروشگاه زرسان{" "}
            <span className="text-base text-white">
              / {userData.user_employee[0].name}
            </span>
          </span>
        </div>
        <div className="flex items-center">
          {EmployeeMenuItems.map((box, index) => {
            return (
              <>
                {box.items.length > 0 ? (
                  <MuiDropDown
                    header={box.header}
                    HeaderIcon={box.headerIcon}
                    menuList={box.items}
                    activeLink={props.activeLink}
                  />
                ) : box.haveBadge == true ? (
                  <MuiBadge count={userData?.chat_num}>
                    <div
                      onClick={() => navigate(box.route)}
                      className="flex items-center text-white cursor-pointer mr-4"
                    >
                      <box.headerIcon />
                      <span className="sidebar-header">{box.header}</span>
                    </div>
                  </MuiBadge>
                ) : (
                  <div
                    onClick={() => navigate(box.route)}
                    className="flex items-center text-white cursor-pointer mr-4"
                  >
                    <box.headerIcon />
                    <span className="sidebar-header">{box.header}</span>
                  </div>
                )}
              </>
            );
          })}
        </div>
        <div className="flex items-center">
          {/* <div
            className="flex items-center text-white cursor-pointer bg-transparent rounded-lg p-2 font-bold transition-all hover:bg-white hover:text-black"
            onClick={() => handleEditCustomerModal()}
          >
            <AccountCircleOutlinedIcon />
            <span className="sidebar-header">پروفایل</span>
          </div> */}
          <div
            className="flex items-center text-white cursor-pointer bg-transparent rounded-lg p-2 font-bold transition-all hover:bg-white hover:text-rose-500"
            onClick={() => authDispatch({ type: "LOGOUT" })}
          >
            <LogoutIcon />
            <span className="mr-2">خروج</span>
          </div>
        </div>
      </div>

      {/* End Desktop Navbar Part */}
      {/* Mobile Navbar Part */}
      <div className="md:hidden min-h-screen">
        <div className="text-center mb-6 md:mb-10">
          <span className="font-bold text-yellow-200 text-2xl md:text-3xl border-b-4 border-yellow-200">
            فروشگاه زرسان
          </span>
        </div>
        <div className="bg-yellow-200 rounded-md py-2 flex justify-center mb-4 md:mb-10">
          <span className="font-bold">{userData.user_employee[0].name}</span>
        </div>
        {EmployeeMenuItems.map((box, index) => {
          return (
            <>
              <div className="bg-white rounded-md p-4 mb-6">
                {box.items.length > 0 ? (
                  <>
                    <div className="flex items-center mb-4">
                      <box.headerIcon />
                      <span className="sidebar-header">{box.header}</span>
                    </div>
                    <ul>
                      {box.items.map((item, index) => {
                        return (
                          <MenuItem
                            route={item.route}
                            isActive={
                              props.activeLink == item.isActive ? true : false
                            }
                            text={item.name}
                          />
                        );
                      })}
                    </ul>
                  </>
                ) : (
                  <>
                    {box.haveBadge ? (
                      <>
                        <MuiBadge count={userData?.chat_num}>
                          <div
                            className="flex items-center"
                            onClick={() => navigate(box.route)}
                          >
                            <box.headerIcon />
                            <span className="sidebar-header">{box.header}</span>
                          </div>
                        </MuiBadge>
                      </>
                    ) : (
                      <>
                        <div
                          className="flex items-center"
                          onClick={() => navigate(box.route)}
                        >
                          <box.headerIcon />
                          <span className="sidebar-header">{box.header}</span>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            </>
          );
        })}
        {/* <div
          onClick={() => handleEditCustomerModal()}
          className="flex items-center cursor-pointer mt-6 rounded-md py-2 px-4 border-2 border-white text-white hover:bg-white hover:text-gray-700 transition-all"
        >
          <AccountCircleOutlinedIcon />
          <span className="sidebar-header">پروفایل</span>
        </div> */}
        <div
          onClick={() => authDispatch({ type: "LOGOUT" })}
          className="flex items-center cursor-pointer mt-6 rounded-md py-2 px-4 border-2 border-white text-white hover:bg-white hover:text-gray-700 transition-all"
        >
          <LogoutIcon />
          <span className="sidebar-header">خروج</span>
        </div>
      </div>
      {/* End Mobile Navbar Part */}
    </>
  );
};

export default EmployeeSideBar;
